import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxPaginationModule } from "ngx-pagination";
import { CalendarModule } from 'primeng/calendar';

import { AppComponent, DocumentUpload, ActivityDescription, ForgotPassword, UpdatePassword, UpLoadDocument, EmployeeList, CreateProject, InterviewStatus, DescriptionDialog } from "./app.component";
import { MaterialModule } from "./material.module";
import { CommonSerService } from "./common-ser.service";
import { routing } from "./app.routing";
import { AuthGuard } from "./auth.guard";


@NgModule({
  declarations: [
    AppComponent,
    EmployeeList,
    DocumentUpload,
    ActivityDescription,
    ForgotPassword,
    UpdatePassword,
    UpLoadDocument,
    CreateProject,
    InterviewStatus,
    DescriptionDialog,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    routing,
    ReactiveFormsModule,
    NgxPaginationModule,
    CalendarModule
  ],
  providers: [
    CommonSerService,
    AuthGuard
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    EmployeeList, DocumentUpload, ActivityDescription, ForgotPassword, UpdatePassword, UpLoadDocument, CreateProject, InterviewStatus,
    DescriptionDialog
  ]

})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Venkat Projects/sagiam-tool-angular/src/app/app.module.ts